<template>
    <div class="page page--center">
        <Header logo-size="xl" disconnect="true" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <div class="card border-light rounded-3 shadow-lg">
                        <div class="card-body">
                            <h2 class="card-title h4 mb-4 text-primary text-center text-md-start">Constanciens</h2>
                            <table id="tab_constanciens" class="table table-striped table-hover table-bordered"></table>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <Footer />

        <div class="modal fade" id="editConstancienModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title h4 text-primary text-center text-md-start">Édition d'un constancien</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                    </div>
                    <div class="modal-body p-8">
                        <form v-if="selectedConstancien" @submit.prevent="editConstancien">
                            <div class="mb-3">
                                <label for="ref">Référence de la demande</label>
                                <input type="text" id="ref" v-model="selectedConstancien.ref" class="form-control" placeholder="Référence demande" required />
                            </div>

                            <div class="border rounded-3 bg-light p-3 mb-3">
                                <div class="mb-3">
                                    <label for="email">Numéro constance :</label>
                                    <strong class="plaintext ms-1 bolt">{{ selectedConstancien.nconstances }}</strong>
                                </div>
                                <div class="mb-3">
                                    <label for="email">Adresse e-mail</label>
                                    <input type="email" id="email" v-model="selectedConstancien.mail" class="form-control" placeholder="Adresse e-mail" required />
                                </div>
                                <div class="mb-3">
                                    <label for="email">Statut du compte :</label>
                                    <strong class="plaintext ms-1 bolt">{{ selectedConstancien.statut }}</strong>
                                </div>
                                <div class="mb-3">
                                    <label for="mobile">Numéro de mobile</label>
                                    <!-- change when MEP code region tel -->
                                    <IntlTelInput
                                        initialCountry="fr"
                                        :load-utils="() => import('intl-tel-input/utils')"
                                        id="mobile"
                                        v-model="selectedConstancien.tel_mobile"
                                        class="form-control"
                                    />      
                                    <!-- <input
                                        type="tel"
                                        id="mobile"
                                        v-model="selectedConstancien.tel_mobile"
                                        class="form-control"
                                        placeholder="Numéro de mobile"
                                        maxlength="10"
                                        @input="selectedConstancien.tel_mobile = selectedConstancien.tel_mobile.replace(/\D/g, '').slice(0, 10)"
                                    /> -->
                                </div>
                                <div class="mb-3">
                                    <label for="otpChannelSwitch">Méthode d'envoi du code</label>
                                    <div class="d-flex align-items-center gap-2">
                                        <span>Email</span>
                                        <div class="form-check form-switch pb-1 d-flex justify-content-center align-items-center">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="otpChannelSwitch"
                                                v-model="selectedConstancien.otp_channel"
                                                true-value="sms"
                                                false-value="email"
                                            >
                                        </div>
                                        <span>SMS</span>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <button type="button" class="btn btn-primary" @click="getTmpPassword">Générer un mot de passe temporaire</button>
                                    <span
                                        v-if="selectedConstancien.tmpPassword"
                                        class="tmp-password"
                                        role="button"
                                        :title="tmpPasswordCopied ? 'Copié !' : 'Cliquer pour copier'"
                                        @click="copyTmpPassword"
                                    >
                                        {{ selectedConstancien.tmpPassword }}
                                        <i class="bi ms-1" :class="tmpPasswordCopied ? 'bi-check-lg' : 'bi-clipboard'"></i>
                                    </span>
                                </div>
                            </div>

                            <div
                                v-if="alert.message"
                                :class="'alert' + (alert ? ' alert-' + alert.class : '') + ' text-center p-1 fs-n1' + (!alert ? ' d-none' : '')"
                                role="alert"
                                v-html="alert ? alert.message : '&nbsp;'"
                            ></div>

                            <button type="submit" class="btn btn-primary rounded-pill" :disabled="loading">Valider</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from 'datatables.net-bs5';
import * as bootstrap from 'bootstrap';
import IntlTelInput from "@intl-tel-input/vue";
import "intl-tel-input/styles";

DataTable.use(bootstrap);

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue' 

export default {
    name: 'AdminDashboard',
    components: {
            Header,
            Footer,
            IntlTelInput
    },
    data: () => ({
        alert: null,
        selectedConstancien: null,
        tmpPasswordCopied: false,
        table: null,
    }),
    methods: {
        ...mapActions(['getConstanciens', 'updateConstanciens', 'logOpenModale']),
        async editConstancien() {
            const res = await this.updateConstanciens(this.selectedConstancien)
            if (res == true) {
                await this.getConstanciens()
                this.table.clear().rows.add(this.adminConstanciens).draw()
                const modalEl = document.getElementById('editConstancienModal');
                bootstrap.Modal.getOrCreateInstance(modalEl).hide();
            } else {
                this.alert = res
            }
        },
        async getTmpPassword() {
            this.tmpPasswordCopied = false
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const specialChars = '?!&$%';
            let password = '';
            for (let i = 0; i < 14; i++) {
                password += chars[Math.floor(Math.random() * chars.length)];
            }

            for (let i = 0; i < 2; i++) {
                const specialChar = specialChars[Math.floor(Math.random() * specialChars.length)];
                const position = Math.floor(Math.random() * (password.length + 1));
                password = password.slice(0, position) + specialChar + password.slice(position);
            }

            this.selectedConstancien.tmpPassword = password;
        },
        async copyTmpPassword() {
            await navigator.clipboard.writeText(this.selectedConstancien.tmpPassword)
            if (!this.tmpPasswordCopied) {   
                this.tmpPasswordCopied = true
                setTimeout(() => { this.tmpPasswordCopied = false }, 2000)
            }
        }
    },
    computed: {
        ...mapState(['loading', 'adminConstanciens']),
    },
    async mounted() {
        await this.getConstanciens()
        this.table = new DataTable('#tab_constanciens', {
            responsive: true,
            data: this.adminConstanciens,
            language: {
                search: 'Rechercher :',
                lengthMenu: 'Afficher _MENU_ éléments',
                info: 'Affichage de _START_ à _END_ sur _TOTAL_ éléments',
                infoEmpty: 'Affichage de 0 à 0 sur 0 élément',
                infoFiltered: '(filtré de _MAX_ éléments au total)',
                zeroRecords: 'Aucun élément à afficher',
                emptyTable: 'Aucune donnée disponible dans le tableau',
                paginate: {
                    first: 'Premier',
                    previous: 'Précédent',
                    next: 'Suivant',
                    last: 'Dernier',
                },
            },
            columns: [
                { data: 'nconstances', title: 'n° constances' },
                { data: 'mail', title: 'Email' },
                { data: 'tel_mobile', title: 'Mobile' },
                { data: 'otp_channel', title: 'Méthode OTP', render: (data) => data || 'email' },
                { data: null, title: '', orderable: false, defaultContent: '<button type="button" class="btn btn-primary btn-sm edit-btn rounded-pill">Modifier</button>' },
            ]
        });

        this.table.on('click', 'button.edit-btn', async (e) => {
            this.alert = {}
            this.tmpPasswordCopied = false

            const row = this.table.row(e.target.closest('tr'));
            this.selectedConstancien = { ...row.data(), otp_channel: row.data().otp_channel || 'sms' };

            await this.logOpenModale({nconstances: this.selectedConstancien.nconstances})

            const modalEl = document.getElementById('editConstancienModal');
            bootstrap.Modal.getOrCreateInstance(modalEl).show();
        });
    },
}
</script>

<style scoped>
table {
    width: 50vw !important;
}

.form-check-input:checked {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.form-check-input:focus {
    border-color: var(--bs-primary);
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
}

.tmp-password {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.6rem;
    background-color: #f1f3f5;
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    font-family: monospace;
    cursor: pointer;
    user-select: all;
}

.tmp-password:hover {
    background-color: #e9ecef;
}

:deep(.iti) {
    width: 100%;
}

:deep(.iti__tel-input) {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}

:deep(.iti__tel-input:focus) {
    color: #212529;
    background-color: #fff;
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>